export default __webpack_public_path__ + "static/media/avatar_117.b2e14a1f.png";